import { forwardRef, useMemo } from "react";
import { useValidation } from "@/shared/forms";
import type { ValueRangeField as ValueRangeFieldProps } from "./types";

export const ValueRangeField = forwardRef<HTMLSelectElement, ValueRangeFieldProps>(function ValueRangeField(
    { ariaLabel, value, onChange, required = false, valueRange, id, ...rest },
    ref,
) {
    useValidation(id, {
        errorLocation: "callout",
        rules: { required },
    });

    const options = useMemo(() => {
        const result = [<option key="" value="" />];
        const { min, max } = valueRange;

        for (let i = min; i <= max; i += 1) {
            result.push(
                <option key={i} value={i.toString()}>
                    {i}
                </option>,
            );
        }

        return result;
    }, [valueRange]);
    return (
        <select
            id={id}
            value={value}
            onChange={onChange}
            required={required}
            aria-label={ariaLabel}
            ref={ref}
            {...rest}
        >
            {options}
        </select>
    );
});
